export default "__VITE_ASSET__C0PVS7f8__"